import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/App";
import { copy } from "@/i18n";

const FEATURED = [
    { img: "/media/gift-50.webp", name: "Gift Card The Market", price: "da 50.–" },
    { img: "/media/tshirt-04-a.webp", name: "T-Shirt", price: "35.–" },
    { img: "/media/cap-05-a.webp", name: "Cappellini", price: "25.–" },
    { img: "/media/buono-cena.webp", name: "Buono Cena per Due", price: "140.–" },
];

const ShopTeaser = () => {
    const { lang } = useLang();
    const c = copy[lang].shopTeaser;

    return (
        <section id="shop" data-testid="shop-teaser-section" className="relative py-20 lg:py-28 overflow-hidden bg-coal/40 border-y border-white/5">
            <div className="absolute bottom-0 -left-40 w-[480px] h-[480px] rounded-full bg-crimson/10 blur-[120px] pointer-events-none" />
            <div className="max-w-7xl mx-auto px-4 sm:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 28 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7 }}
                    className="text-center"
                >
                    <span className="text-xs sm:text-sm font-semibold tracking-[0.2em] uppercase text-crimson">
                        {c.label}
                    </span>
                    <h2 className="mt-4 font-display font-extrabold uppercase tracking-tight text-2xl sm:text-4xl lg:text-5xl">
                        {c.title}
                    </h2>
                    <p className="mt-4 text-neutral-400 max-w-xl mx-auto text-sm sm:text-base">{c.subtitle}</p>
                </motion.div>

                <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
                    {FEATURED.map((p, i) => (
                        <motion.div
                            key={i}
                            data-testid={`shop-teaser-item-${i}`}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.6, delay: i * 0.1 }}
                            className="rounded-2xl border border-white/10 bg-card overflow-hidden group"
                        >
                            <div className="relative aspect-square bg-coal overflow-hidden">
                                <img
                                    src={p.img}
                                    alt={p.name}
                                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                                    loading="lazy"
                                />
                            </div>
                            <div className="p-4 flex items-baseline justify-between gap-2">
                                <h3 className="font-heading font-bold text-sm">{p.name}</h3>
                                <span className="font-mono text-crimson-bright font-semibold text-sm whitespace-nowrap">{p.price}</span>
                            </div>
                        </motion.div>
                    ))}
                </div>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="mt-10 text-center"
                >
                    <Link
                        to="/shop"
                        data-testid="shop-teaser-cta"
                        className="inline-flex items-center gap-2 rounded-full bg-crimson hover:bg-crimson-bright text-white text-xs sm:text-sm font-bold uppercase tracking-[0.15em] px-8 py-4 transition-colors"
                    >
                        {c.cta}
                        <ArrowRight size={16} />
                    </Link>
                </motion.div>
            </div>
        </section>
    );
};

export default ShopTeaser;
